import { render, staticRenderFns } from "./AdminApplication.vue?vue&type=template&id=726798ec"
import script from "./AdminApplication.vue?vue&type=script&lang=js"
export * from "./AdminApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726798ec')) {
      api.createRecord('726798ec', component.options)
    } else {
      api.reload('726798ec', component.options)
    }
    module.hot.accept("./AdminApplication.vue?vue&type=template&id=726798ec", function () {
      api.rerender('726798ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminApplication.vue"
export default component.exports